<template>
  <footer class="footerStyle">
    <!-- Social Media Links -->
    <div class="socialMedia">
      <a
        target="_blank"
        title="Facebook de XtrimPro"
        href="https://www.facebook.com/profile.php?id=100090370913056"
      >
        <i
          class="fab fa-facebook-f"
          style="color: white; font-size: 25px; margin-right: 10px"
          aria-hidden="true"
        ></i>
      </a>
      <a
        target="_blank"
        title="Instagram de XtrimPro"
        href="https://www.instagram.com/xtrimpro.ec/"
      >
        <i
          class="fab fa-instagram"
          style="color: white; font-size: 25px; margin-right: 10px"
          aria-hidden="true"
        ></i>
      </a>
      <a
        target="_blank"
        title="Email de XtrimPro"
        href="mailto:hola@xtrimproec.com?Subject=Tengo%20una%20pregunta"
      >
        <i
          class="fas fa-envelope"
          style="color: white; font-size: 25px; margin-right: 10px"
          aria-hidden="true"
        ></i>
      </a>
      <a
        target="_blank"
        title="Tiktok de XtrimPro"
        href="https://www.tiktok.com/@xtrimproec"
      >
        <i
          class="fab fa-tiktok"
          style="color: white; font-size: 25px; margin-right: 10px"
          aria-hidden="true"
        ></i>
      </a>
      <a
        target="_blank"
        title="Whatsapp de XtrimPro"
        href="https://api.whatsapp.com/send?phone=593995756176&text=Hola,%20deseo%20obtener%20informaci%C3%B3n%20sobre%20XtrimPro"
      >
        <i
          class="fab fa-whatsapp"
          style="color: white; font-size: 25px; margin-right: 10px"
          aria-hidden="true"
        ></i>
      </a>
    </div>

    <!-- Terms and Links -->
    <p
      style="
        margin-top: 10px;
        margin-bottom: 0;
        font-size: 12px;
        text-align: center;
        color: white;
      "
    >
      <a
        href="https://firebasestorage.googleapis.com/v0/b/xtrimpro-refiereygana.firebasestorage.app/o/legal%2FTe%CC%81rminos-Y-Condiciones.pdf?alt=media&token=4794f901-fd8f-4496-a2a2-e08448d270a6"
        target="_blank"
        style="color: white; font-weight: 600"
        >Términos y condiciones</a
      >
      -
      <a
        href="https://firebasestorage.googleapis.com/v0/b/xtrimpro-refiereygana.firebasestorage.app/o/legal%2FPoli%CC%81ticas-De-Privacidad.pdf?alt=media&token=a0268cf7-8712-4f80-aed2-a6c0237f88f6"
        target="_blank"
        style="color: white; font-weight: 600"
        >Política de privacidad</a
      >
      -
      <a
        href="https://firebasestorage.googleapis.com/v0/b/xtrimpro-refiereygana.firebasestorage.app/o/legal%2FAviso-Legal.pdf?alt=media&token=d5d886e9-e844-4037-995c-8d39edbd7503"
        target="_blank"
        style="color: white; font-weight: 600"
        >Aviso legal</a
      >-
      <a
        href="https://firebasestorage.googleapis.com/v0/b/xtrimpro-refiereygana.firebasestorage.app/o/legal%2FDisclaimer.pdf?alt=media&token=52468f4b-ee80-4117-a77f-84d90ad0551f"
        target="_blank"
        style="color: white; font-weight: 600"
        >Disclaimer</a
      >
    </p>

    <!-- Copyright -->
    <p
      style="
        margin-top: 6px;
        font-size: 12px;
        margin-bottom: 10px;
        color: #ffcc03;
        font-weight: 700;
      "
    >
      Copyright &copy; {{ year }} XtrimPro
      <a href="https://xtrimpro.ec" target="_blank" style="color: white"
        >- Powered by PlanPro</a
      >
    </p>
  </footer>
</template>

<script>
export default {
  name: "WhiteFooterComponent",
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped>
.footerStyle {
  color: black !important;
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 20px 30px 20px;
}

.socialMedia {
  display: flex;
}
</style>
